import { render, staticRenderFns } from "./TelaPrincipal.vue?vue&type=template&id=f98b0018"
import script from "./TelaPrincipal.vue?vue&type=script&lang=js"
export * from "./TelaPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports